import en from './en-us.json'
import he from './he-il.json'
import de from './de.json'
import ar from './ar.json'
import fr from './fr.json'
import es from './es.json'
import it from './it.json'
import ru from './ru.json'
import ko from './ko.json'
import pt from './pt.json'
import tr from './tr.json'
import el from './el.json'
import zh from './zh.json'
import lt from './lt.json'
import sk from './sk.json'
import hi from './hi.json'
import hu from './hu.json'
import nl from './nl.json'
import nb from './nb.json'
import ro from './ro.json'
import sv from './sv.json'
import th from './th.json'
import vi from './vi.json'
import ja from './ja.json'
import pl from './pl.json'

//new lang add here #1/4
export default {
  en,
  he,
  es,
  de,
  fr,
  it,
  ar,
  zh,
  ko,
  ru,
  pt,
  tr,
  el,
  lt,
  sk,
  hi,
  hu,
  nl,
  nb,
  ro,
  sv,
  th,
  vi,
  ja,
  pl,
}
